<script setup>
const { data } = defineProps(['data'])
const attrs = useAttrs()

function trackClick(e, { text, url }) {
  pushEventToDataLayer('custom.menu.link', {
    group: 'trust well',
    type: 'UtilityPanelTrustwell',
    category: 'UtilityPanelTrustwell',
    label: text,
    info: {
      url,
      element: e?.target?.tagName,
      location: 'footer',
    },
  })
}
</script>

<template>
  <div v-for="({ link, icon }, i) of data" :key="i" class="footer__top-section-icon-link">
    <Anchor class="footer__top-section-icon-anchor" :url="link.url" @click="trackClick($event, link)">
      <img :id="icon.id" :src="icon.url" alt="" :width="icon.width" :height="icon.height ?? '2rem'" v-bind="attrs" />
    </Anchor>
    <Anchor :id="link.id" :url="link.url" @click="trackClick($event, link)">
      {{ link.text }}
    </Anchor>
  </div>
</template>

<style scoped lang="postcss">
.footer__top-section-icon-link {
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: var(--space-50);

  .footer__top-section-icon-anchor {
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  a {
    font-size: var(--text-small);
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  }
  a:hover {
    text-decoration: underline;
  }

  @media (--mobile-only) {
    height: 5rem;
    width: 5rem;
    a {
      font-size: var(--text-xsmall);
    }
  }
}
</style>
